import { useEffect, useRef } from "react";
import {
  COOKIE_CONSENT_STATUSES,
  recordCookieConsent,
} from "../service/portalEventsClient";

const readCookiebotConsentStatus = () => {
  if (typeof window === "undefined" || !window.Cookiebot) return null;

  if (window.Cookiebot.hasResponse === false) {
    return COOKIE_CONSENT_STATUSES.pending;
  }

  const consent = window.Cookiebot.consent || {};
  const hasOptionalConsent =
    consent.preferences === true ||
    consent.statistics === true ||
    consent.marketing === true;

  return hasOptionalConsent
    ? COOKIE_CONSENT_STATUSES.accepted
    : COOKIE_CONSENT_STATUSES.rejected;
};

export default function useCookieConsentPersistence() {
  const lastPersistedStatusRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const persistStatus = (status) => {
      if (!status || lastPersistedStatusRef.current === status) return;
      lastPersistedStatusRef.current = status;
      recordCookieConsent({ status }).catch(() => {});
    };

    const persistCurrentStatus = () => {
      persistStatus(readCookiebotConsentStatus());
    };

    const persistAccepted = () => {
      persistStatus(COOKIE_CONSENT_STATUSES.accepted);
    };

    const persistRejected = () => {
      persistStatus(COOKIE_CONSENT_STATUSES.rejected);
    };

    window.addEventListener("CookiebotOnAccept", persistAccepted);
    window.addEventListener("CookiebotOnDecline", persistRejected);
    window.addEventListener("CookiebotOnConsentReady", persistCurrentStatus);
    persistCurrentStatus();

    return () => {
      window.removeEventListener("CookiebotOnAccept", persistAccepted);
      window.removeEventListener("CookiebotOnDecline", persistRejected);
      window.removeEventListener("CookiebotOnConsentReady", persistCurrentStatus);
    };
  }, []);
}
